export default __webpack_public_path__ + "static/media/sante.1fa717e0.svg";